import { createAction } from '../../utils';

export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const OPEN_ORDER_TRACKER_POPUP = 'OPEN_ORDER_TRACKER_POPUP';
export const CLOSE_ORDER_TRACKER_POPUP = 'CLOSE_ORDER_TRACKER_POPUP';
export const CLEAR_ANALYTICS = 'CLEAR_ANALYTICS';
export const TRIGGER_ANALYTICS = 'TRIGGER_ANALYTICS';
export const INIT_SUMMARY_PAGE_START = 'INIT_SUMMARY_PAGE_START';
export const SET_DATA_TO_STORE = 'SET_DATA_TO_STORE';
export const SET_CACHED_DATA_TO_STORE = 'SET_CACHED_DATA_TO_STORE';
export const SET_AEM_PROPS_TO_STORE = 'SET_AEM_PROPS_TO_STORE';
export const CLEAR_CACHED_DATA = 'CLEAR_CACHED_DATA';
export const CLEAR_STATE = 'CLEAR_STATE';
export const CLOSE_AMEND_APPOINTMENT_MODAL = 'CLOSE_AMEND_APPOINTMENT_MODAL';
export const UPDATE_APPOINTMENT_DATE_AND_TIME = 'UPDATE_APPOINTMENT_DATE_AND_TIME';
export const SELECT_SITE_CONTACT = 'SELECT_SITE_CONTACT';
export const ADD_NEW_SITE_CONTACT = 'ADD_NEW_SITE_CONTACT';
export const INIT_AMEND_APPOINTMENT_FLOW = 'INIT_AMEND_APPOINTMENT_FLOW';
export const SET_CURRENT_APPOINTMENT_INFO = 'SET_CURRENT_APPOINTMENT_INFO';
export const UPDATE_APPOINTMENT_BY_ID = 'UPDATE_APPOINTMENT_BY_ID';
export const INIT_AMEND_APPOINTMENT_FLOW_SUCCEED = 'INIT_AMEND_APPOINTMENT_FLOW_SUCCEED';
export const SHOW_ADD_NEW_CONTACT_FORM = 'SHOW_ADD_NEW_CONTACT_FORM';
export const SET_IS_READY_TO_CONFIRM = 'SET_IS_READY_TO_CONFIRM';
export const SET_NOTIFICATION_TYPE = 'SET_NOTIFICATION_TYPE';
export const HIDE_NOTIFICATION = 'HIDE_NOTIFICATION';

// init actions
export const initSummaryPage = createAction(INIT_SUMMARY_PAGE_START);
export const setDataToStore = createAction(SET_DATA_TO_STORE);
export const clearAnalytics = createAction(CLEAR_ANALYTICS);
export const triggerAnalytics = createAction(TRIGGER_ANALYTICS);
export const setCachedDataToStore = createAction(SET_CACHED_DATA_TO_STORE);
export const setAEMPropsToStore = createAction(SET_AEM_PROPS_TO_STORE);
export const clearCachedData = createAction(CLEAR_CACHED_DATA);
export const clearState = createAction(CLEAR_STATE);

// modal actions
export const openModal = createAction(OPEN_MODAL);
export const closeModal = createAction(CLOSE_MODAL);

// popup order tracker actions
export const openOTPopUp = createAction(OPEN_ORDER_TRACKER_POPUP);
export const closeOTPopUp = createAction(CLOSE_ORDER_TRACKER_POPUP);

// amend appointment modal actions
export const closeAmendAppointmentModal = createAction(CLOSE_AMEND_APPOINTMENT_MODAL);
export const initAmendAppointmentFlow = createAction(INIT_AMEND_APPOINTMENT_FLOW);
export const setCurrentAppointmentInfo = createAction(SET_CURRENT_APPOINTMENT_INFO);
export const updateAppointmentById = createAction(UPDATE_APPOINTMENT_BY_ID);
export const initAmendAppointmentFlowSucceed = createAction(INIT_AMEND_APPOINTMENT_FLOW_SUCCEED);
export const updateAppointmentDateAndTime = createAction(UPDATE_APPOINTMENT_DATE_AND_TIME);
export const selectSiteContact = createAction(SELECT_SITE_CONTACT);
export const addNewSiteContact = createAction(ADD_NEW_SITE_CONTACT);
export const showAddNewContactForm = createAction(SHOW_ADD_NEW_CONTACT_FORM);
export const setIsReadyToConfirm = createAction(SET_IS_READY_TO_CONFIRM);
export const setNotificationType = createAction(SET_NOTIFICATION_TYPE);
export const hideNotification = createAction(HIDE_NOTIFICATION);
